<template>
  <div>
    <form name="contract" class="needs-validation" novalidate>
      <div
        id="alert"
        class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
        :class="alert.color"
        role="alert"
        v-if="alert.message"
      >
        <button type="button" class="close" aria-label="Close" @click="alert.message = ''"></button>
        <i :class="alert.icon"></i> &nbsp;
        <strong>{{ alert.message }}</strong>
        <br />
        {{ alert.reason }}
      </div>

      <div class="row mt-3">
        <div class="col-md-12">
          <label for="note">Nome</label>
          <div class="input-group">
            <input type="text" class="form-control" placeholder v-model="data.name" />
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-12">
          <label for="note">Upload de contrato</label>
          <div class="input-group">
            <input
              accept="image/jpeg, image/gif, image/png, application/pdf, image/x-eps"
              type="file"
              class="form-control"
              name="fileUpload"
              ref="fileInput"
              @change="chooseFile"
            />
          </div>
        </div>
      </div>

      <hr class="row mt-5 mb-3" />

      <div class="row mb-5">
        <div class="col-md-12 text-right">
          <button
            @click.prevent="saveForm"
            class="btn"
            :class="{ 'btn-metal': !formIsValid, 'btn-focus': formIsValid }"
            :disabled="!formIsValid"
          >
            <i class="fas fa-save" v-if="formIsValid"></i>
            <i class="fas fa-exclamation-triangle" v-else></i>
            Salvar
          </button>
        </div>
      </div>
    </form>

    <div id="accordion" v-if="data.length > 0">
      <h3 class="center text-center">Cadastrados</h3>
      <div>
        <button
          class="btn btn-link"
          data-toggle="collapse"
          data-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          <i class="fal fa-plus fa-lg"></i>
        </button>
      </div>
      <div v-for="upload in data" :key="upload.id">
        <div class="card">
          <div class="card-header">
            <input
              type="text"
              placeholder
              v-model="upload.name"
              @change="changeData(upload.id, { name: upload.name })"
            />
          </div>

          <div id="collapseOne" class="collapse" data-parent="#accordion">
            <div class="card-body">
              <div class="row">
                <div class="col-10">
                  <input
                    type="tel"
                    class="v-money form-control m-input"
                    v-model="upload.path"
                    @change="changeData(upload.id, { path: upload.path })"
                  />
                </div>
                <div class="m-form__group form-group col-sm">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-danger m-btn m-btn--custom mt-1"
                    @click="confirmDel(upload.id)"
                    v-b-tooltip.hover.left
                    title="Excluir"
                    :disabled="!upload.id"
                  >
                    <i class="fal fa-trash-alt fa-lg"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { baseApiUrl, baseLambdaUploadUrl, baseS3Url } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageFormMixin],
  name: 'CustomerContractSaveForm',
  data() {
    return {
      data: [],
      response: false,
      file: {
        selected: false,
      },
    };
  },
  methods: {
    changeData(id, name) {
      const urlForm = `${baseApiUrl}/v1/customer/upload/edit/${id}`;
      axios
        .post(urlForm, name)
        .then((res) => {
          this.reset();
          this.logMessageForm(res);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error));
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir o upload selecionado?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          }
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/customer/upload/delete/${id}`;
      axios(url)
        .then((res) => {
          this.logMessageForm(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    reset() {
      const input = this.$refs.fileInput;
      input.type = 'text';
      input.type = 'file';
    },
    chooseFile(e) {
      this.file.selected = e;
      this.data.file = e;
    },
    saveForm() {
      this.messageWaitingSave();

      const e = this.file.selected;
      const { files } = e.target;
      const file = files[0];

      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', this.data.name);
      formData.append('contract_id', this.contractId);
      formData.append('pathFile', `contracts/${this.$store.state.showContractSave}`);

      const urlForm = `${baseApiUrl}/v1/customer/upload/save`;
      axios
        .post(urlForm, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => {
          this.reset();
          this.logMessageForm(res);
          this.callData();
        })
        .catch((error) => this.logMessageFormFailed(error));
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/upload/data/${this.$store.state.showContractSave}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
    callData() {
      this.getDatas();
    },
  },
  computed: {
    contractId() {
      return this.$store.state.showContractSave;
    },
    formIsValid() {
      if (this.data.name && this.file.selected != false) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.contractId && this.contractId != 'add') {
      this.callData();
    }
  },
};
</script>

<style></style>
